import { defineMessages } from 'react-intl';

export default defineMessages({
  removeAccountIconLabel: {
    id: 'remove.account.icon.label',
    defaultMessage: 'Remove account',
    description: '',
  },
  removeAccountDialogConfirm: {
    id: 'remove.account.dialog.confirm',
    defaultMessage: 'Remove',
    description: '',
  },
  removeAccountDialogClose: {
    id: 'remove.account.dialog.close',
    defaultMessage: 'Cancel',
    description: '',
  },
});
